// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentOverviewWhyReadArticle_container__1cOKk","reasonItem":"ContentOverviewWhyReadArticle_reasonItem__1KQba"};